module.exports = __webpack_public_path__ + "static/media/nwhacks2019.ff4c53f9.jpg";